<section class="cmn-innerpage-wrapper quotation">
    <ag-grid-angular
      style="width: 100%"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [suppressRowClickSelection]="true"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [class]="themeClass"
      (cellClicked)="onCellClicked($event)"
    />
    <div class="pagination-wrapper">
      <div class="page-size">
        <label for="pageSize">Page Size:</label>
        <select
          id="pageSize"
          [(ngModel)]="pageSize"
          (change)="onPageSizeChange($event)"
        >
          <option *ngFor="let size of pageSizeOptions" [value]="size">
            {{ size }}
          </option>
        </select>
      </div>
      <div class="page-nav" *ngIf="totalPages > 1">
        <button class="prev" (click)="prevPage()" [disabled]="page === 0">
          <img
            src="../../../assets/images/icons/arrow.svg"
            alt="prev arrow"
            srcset=""
          />
        </button>
        <span> Page {{ page + 1 }} of {{ totalPages }} </span>
        <button
          class="next"
          (click)="nextPage()"
          [disabled]="page + 1 >= totalPages"
        >
          <img
            src="../../../assets/images/icons/arrow.svg"
            alt="next arrow"
            srcset=""
          />
        </button>
      </div>
    </div>
  </section>
  